module.exports = __webpack_public_path__ + "img/baggage_hover_49b575b.webp";